import { createCallController as createPrototypeCallController } from '../call-prototype/controller/callController.js';
import { BrowserMediaAdapter } from '../call-prototype/adapters/browserMediaAdapter.js';
import { BrowserPeerConnectionAdapter } from '../call-prototype/adapters/browserPeerConnectionAdapter.js';
import { BrowserSignalingAdapter } from '../call-prototype/adapters/browserSignalingAdapter.js';

export const createCallController = ({
    signalingUrl,
    rtcConfigProvider,
    allowServerCallStateSnapshots = true
}) => {
    if (!signalingUrl) {
        throw new Error('Missing signaling URL for call controller.');
    }

    if (typeof rtcConfigProvider !== 'function') {
        throw new Error('Missing rtcConfigProvider for call controller.');
    }

    const mediaAdapter = new BrowserMediaAdapter();
    const signalingAdapter = new BrowserSignalingAdapter();
    const peerConnectionAdapter = new BrowserPeerConnectionAdapter({
        mediaAdapter
    });

    const controller = createPrototypeCallController({
        signalingAdapter,
        mediaAdapter,
        peerConnectionAdapter,
        signalingUrl,
        rtcConfigProvider,
        allowServerCallStateSnapshots
    });

    return {
        controller,
        adapters: {
            mediaAdapter,
            signalingAdapter,
            peerConnectionAdapter
        }
    };
};
